export const SUPER_ADMIN_ROLE_ACCESS = [1];
export const ORGANISATION_ADMIN_ROLE_IDs = [25];
export const ORGANISATION_MANAGER_IDs = [26];
export const ORGANISATION_SUPERVISORS_IDs = [27];
export const ORGANISATION_OPERATOR_IDs = [28];

export const USER_ROLES = [
  { label: "Organisation Admin", value: "organisation_admin", color: "gold", avatarColor: "#D48806", ids: ORGANISATION_ADMIN_ROLE_IDs },
  { label: "Manager", value: "manager", color: "geekblue", avatarColor: "#1D39C4", ids: ORGANISATION_MANAGER_IDs },
  { label: "Supervisor", value: "supervisor", color: "purple", avatarColor: "#722ED1", ids: ORGANISATION_SUPERVISORS_IDs },
  { label: "Operator", value: "operator", color: "green", avatarColor: "#389E0D", ids: ORGANISATION_OPERATOR_IDs },
];
